import { Course } from 'src/store/models/timetable/index.js'

import CRUD from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'
import Users from 'src/api/users.js'

export class Subject extends CRUD {
  static entity = 'subjects'
  static fetchUrl = Timetable.timetableSubjectsUrl()

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      name: this.string(''),
      shortcut: this.string(''),
      description: this.string(''),
      content: this.string(''),
      color: this.string('blue'), // fallback
      user_color: this.attr(null),
      intern_id: this.string(''),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      meta: this.attr({}),
      courses: this.hasMany(Course, 'subject_id')
    }
  }

  static async setColor (subjectId, color) {
    const Subject = this.find(subjectId)
    this.insertOrUpdate({ data: { ...Subject, color, user_color: color } })

    return Users.postSelfTimetableSubjectColor({ subject_id: subjectId, color: color }, { showMessages: false })
  }

  static async getUpdatedSubject (subjectId) {
    const res = await Timetable.getTimetableSubject(subjectId)

    Subject.insertOrUpdate({ data: res.data })
    return res
  }
}

export default Subject
